import React, { useState } from 'react'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import ActionIconButton from '../common/ActionIconButton';

const CopyButton = ({ row }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(JSON.stringify(row));
        setCopied(true);

        // Reset the copied state after a short delay
        setTimeout(() => {
            setCopied(false);
        }, 2000);
    };

    return (
        <ActionIconButton
            title={copied ? 'Copied' : 'Copy JSON'}
            onClick={handleCopy}
            icon={copied ? <CheckIcon color="success" fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
        />
    );
};

export default CopyButton